var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card d-flex",staticStyle:{"min-height":"60vh"}},[_c('div',{staticClass:"card-body"},[_c('b-button',{on:{"click":function($event){return _vm.$router.back()}}},[_c('i',{staticClass:"fas fa-arrow-left me-1"}),_vm._v(" Documents ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }